/**
 * 站点级配置与 SEO 长尾词库（静态数据，仅用于前端展示）
 */

export const categories = [
  { key: "ceo", label: "霸道总裁" },
  { key: "city", label: "都市战神" },
  { key: "war", label: "战神归来" },
  { key: "sweet", label: "甜宠虐恋" },
  { key: "revenge", label: "穿越复仇" },
  { key: "ancient", label: "古装权谋" },
  { key: "suspense", label: "悬疑推理" },
  { key: "era", label: "年代情感" },
];

export const navCategories = [
  { label: "首页", to: "/" },
  { label: "霸道总裁", to: "/category?type=ceo" },
  { label: "都市战神", to: "/category?type=city" },
  { label: "甜宠虐恋", to: "/category?type=sweet" },
  { label: "穿越复仇", to: "/category?type=revenge" },
  { label: "古装权谋", to: "/category?type=ancient" },
  { label: "悬疑推理", to: "/category?type=suspense" },
];

export const regionOptions = [
  { key: "all", label: "全部地区" },
  { key: "mainland", label: "内地" },
  { key: "hk", label: "港台" },
  { key: "jpkr", label: "日韩" },
  { key: "west", label: "欧美" },
];

export const yearOptions = [
  { key: "all", label: "全部年份" },
  { key: "2026", label: "2026" },
  { key: "2025", label: "2025" },
  { key: "2024", label: "2024" },
  { key: "2023", label: "2023" },
];

export const statusOptions = [
  { key: "all", label: "全部状态" },
  { key: "ongoing", label: "连载中" },
  { key: "done", label: "已完结" },
];

export const sortOptions = [
  { key: "new", label: "最新上线" },
  { key: "hot", label: "最热播放" },
  { key: "rating", label: "评分最高" },
];

export const quickFilters = [
  { key: "update", label: "最新更新", icon: "ri-flashlight-line" },
  { key: "weekly", label: "本周热播", icon: "ri-fire-line" },
  { key: "finished", label: "完结精选", icon: "ri-checkbox-circle-line" },
  { key: "top", label: "高分推荐", icon: "ri-award-line" },
];

export const hotKeywords = [
  "总裁的替身新娘",
  "都市战神归来",
  "甜宠小娇妻",
  "重生复仇千金",
  "穿越成王妃",
  "八零辣妻",
  "隐婚老公是大佬",
  "江湖不良人",
];

export const friendLinks = [
  { label: "短剧排行榜", href: "https://www.juyan-drama.com/ranking" },
  { label: "影视剧集库", href: "https://www.juyan-drama.com/library" },
  { label: "高清片花预告", href: "https://www.juyan-drama.com/trailer" },
  { label: "演员资料库", href: "https://www.juyan-drama.com/star" },
  { label: "短剧行业观察", href: "https://www.juyan-drama.com/insight" },
  { label: "剧迷社区", href: "https://www.juyan-drama.com/community" },
];

export const seoKeywordCloud = [
  "微短剧在线观看",
  "短剧全集免费",
  "霸道总裁短剧",
  "都市战神短剧",
  "战神归来全集",
  "甜宠虐恋短剧",
  "穿越复仇爽剧",
  "古装权谋短剧",
  "悬疑推理短剧",
  "年代情感剧",
  "重生复仇短剧",
  "豪门恩怨短剧",
  "逆袭打脸短剧",
  "高清短剧网站",
  "短剧排行榜2026",
  "每日更新短剧",
  "免费追剧网站",
  "短剧高清1080p",
  "短剧分集剧情",
  "微短剧推荐",
];